
import {catchError, share, retry, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { ApiService } from '../../../app/provider/api.service';
import { Observable } from 'rxjs';
// import {GenererFactureRecapOp} from '../../model/index';
import { ConstService } from '../../const.service';

@Injectable()
export class FactureUpdateService {

    apiUrl : string ;
    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private constService: ConstService, private apiService: ApiService) {
        this.apiUrl = constService.baseUrlPC+ "/factures" ;
    }
    
    /*
    updateFacture(numerosFactures : string) {
        
        return this.apiService.put(this.apiUrl+"/update-facture/"+numerosFactures, "")
            .map(res => res)
            .catch(this.constService.handleError);
    }
    */

    updateFactureOffre(numerosFactures : string) {
        return this.apiService.post(this.apiUrl+"/update-facture", numerosFactures).pipe(
            map(res => res),
            retry(0),
            share(),
            catchError(this.constService.handleError),);
    }

    contratsForRetablissement(numerosFactures : string) {
        return this.apiService.post(this.apiUrl+"/contrats-retablissement", numerosFactures);
    }
    contratsForRetablissementClient(id : any) {
        return this.apiService.get(this.apiUrl+"/contrats-retablissement-client?id="+id);
    }

    // genererFactureRecap(op : GenererFactureRecapOp) {
    //     return this.apiService.post(this.apiUrl+"/generer-facture-recap", op);
    // }

    findFactureRecap(id : any) {
        return this.apiService.get(this.apiUrl+"/find-facture-recap?id="+id);
    }

    printFactureIsolle(numeroFacture: string):Observable<any>{ 
        let myheaders = new Headers();
        myheaders.append('Content-Type', 'application/json'); 
        myheaders.set('Authorization', `Basic ${sessionStorage.getItem('SESSION_TOKEN')}`);
        let options = {headers: myheaders, responseType: 'blob'} as any;   
        return this.apiService.get(this.apiUrl+ "/" + numeroFacture + "/print",this.constService.baseOptionBlob);
    }

    normaliser(numeroFacture: string):Observable<any>{ 
        let myheaders = new Headers();
        myheaders.append('Content-Type', 'application/json'); 
        myheaders.set('Authorization', `Basic ${sessionStorage.getItem('SESSION_TOKEN')}`);
        let options = {headers: myheaders, responseType: 'blob'} as any;   
        return this.apiService.get(this.apiUrl+ "/normaliser?n=" + numeroFacture ,this.constService.baseOptionBlob);
    }

    
    proforma(cotationcmo: any):Observable<any>{ 
        let myheaders = new Headers();
        myheaders.append('Content-Type', 'application/json'); 
        myheaders.set('Authorization', `Basic ${sessionStorage.getItem('SESSION_TOKEN')}`);
        let options = {headers: myheaders, responseType: 'blob'} as any;  
        return this.apiService.post(this.apiUrl+"/generer-facture-cotation", cotationcmo, options) ;
       // return this.apiService.get(this.apiUrl+ "/" + numeroFacture + "/print", options);
    }


    printFactureOracle(numeroFacture: string):Observable<any>{ 
        let myheaders = new Headers();
        myheaders.append('Content-Type', 'application/json'); 
        myheaders.set('Authorization', `Basic ${sessionStorage.getItem('SESSION_TOKEN')}`);
        let options = {headers: myheaders, responseType: 'blob'} as any;   
        return this.apiService.get(this.apiUrl + "/print-dcf?n=" + numeroFacture, this.constService.baseOptionBlob);
    }

    
    
}
